export default "__VITE_ASSET__tN6Iycm8__"